import * as React from 'react'
import { connect } from 'react-redux'
import { ContactsListComponent } from './ContactsList'
import { replace } from 'react-router-redux'
import { showContactCreateModal } from '../ContactCreateModal'
import { showContactImportModal } from '../ContactImportModal'
import { reduxForm } from 'redux-form'
import { flow } from 'lodash'

const form = 'contactsList'

export interface IContactListContainerProps {
  page: number
  search?: string
}

const stateToProps = ({}, { search }: IContactListContainerProps) => ({
  initialValues: {
    search,
  },
})

export const dispatchToProps = {
  replace,
  showContactCreateModal,
  showContactImportModal,
}

export const ContactsList = flow<any, any, React.SFC<IContactListContainerProps>>(
  reduxForm({ form, enableReinitialize: true }),
  connect(stateToProps, dispatchToProps)
)(ContactsListComponent)



// WEBPACK FOOTER //
// src/features/Contacts/ContactsList/ContactsList.container.ts